import { WebApiService } from '../services/web-api-service';
import { autoinject } from 'aurelia-framework';

@autoinject()
export class DashboardController {
    constructor(private api: WebApiService) {
    }

    navigatedFromFailedLogin: boolean;
    email:string;
    password:string;

    completeItem(item: any): Promise<any> {
        return this.api.get("WorkQueue", "CompleteWorkItem", { id: item.id });
    }

    getWorkItems(): Promise<any> {
        return this.api.get("WorkQueue", "GetWorkQueue");
    }

    //changePassword():Promise<void>{
    //    return this.api.post("Login", "ChangePassword", { email: email, password: password });
    //}

}
